import type { FC } from "react";
import { Button } from "@/components/button";
import { FavoriteButton } from "./favorite-button";
import type { CardLayoutProps } from "./layout-props";
import { PractitionerAvatar } from "./practitioner-avatar";
import { ProfessionList } from "./profession-list";
import { SkeletonBar } from "./skeleton-bar";
import { SummaryCardMeta } from "./summary-card-meta";
import { VerifiedName } from "./verified-name";

const StickyLayoutSkeleton: FC = () => (
  <>
    <div className="skeleton-bar-dark h-156 w-152 rounded-large" />
    <SkeletonBar tone="dark" className="h-32 w-3/5" />
    <div className="flex w-full flex-col items-center gap-8">
      <SkeletonBar className="w-3/5" />
      <SkeletonBar className="w-2/5" />
      <SkeletonBar className="w-4/5" />
    </div>
    <hr className="w-full border-neutral-light-grey" />
    <SkeletonBar className="h-48 w-full" />
  </>
);

export const StickyLayout: FC<CardLayoutProps> = ({ content, onContact, favorited, onFavoriteToggle, loading }) => {
  if (!content || loading) return <StickyLayoutSkeleton />;

  const { name, verified, professions, location, years, photoUrl, footnote } = content;

  return (
    <>
      {onFavoriteToggle && (
        <FavoriteButton
          active={favorited}
          onClick={onFavoriteToggle}
          className="absolute right-16 top-16 size-36"
          iconClassName="size-28"
        />
      )}
      <PractitionerAvatar name={name} photoUrl={photoUrl} className="h-156 w-152 rounded-large" />
      <VerifiedName name={name} verified={verified} size="m" />
      <SummaryCardMeta
        profession={professions.length > 0 ? <ProfessionList entries={professions} /> : undefined}
        yearsOfExperience={years}
        location={location}
        textClassName="text-16"
      />
      <hr className="w-full border-neutral-light-grey" />
      <Button onClick={onContact} size="l" variant="primary-dark-blue" className="w-full">
        Contact Me
      </Button>
      {footnote && <p className="w-full text-12 text-center text-neutral-black/70">{footnote}</p>}
    </>
  );
};
